var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoto = function SvgMoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 1.96818C12.6129 1.18754 11.9741 0.548828 11.1935 0.548828H9.06447V1.96818H11.1935V3.84883L8.72382 6.93592H6.22576V3.38754H3.38705C1.81866 3.38754 0.54834 4.65786 0.54834 6.22625V8.35528H1.96769C1.96769 9.53334 2.91866 10.4843 4.09673 10.4843C5.27479 10.4843 6.22576 9.53334 6.22576 8.35528H9.40511L12.6129 4.3456V1.96818ZM4.09673 9.06496C3.7064 9.06496 3.38705 8.7456 3.38705 8.35528H4.8064C4.8064 8.7456 4.48705 9.06496 4.09673 9.06496Z",
    fill: "#007141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67737 1.25891H6.22576V2.67827H2.67737V1.25891ZM12.6129 6.22665C11.4348 6.22665 10.4838 7.17762 10.4838 8.35569C10.4838 9.53375 11.4348 10.4847 12.6129 10.4847C13.7909 10.4847 14.7419 9.53375 14.7419 8.35569C14.7419 7.17762 13.7909 6.22665 12.6129 6.22665ZM12.6129 9.06536C12.2225 9.06536 11.9032 8.74601 11.9032 8.35569C11.9032 7.96536 12.2225 7.64601 12.6129 7.64601C13.0032 7.64601 13.3225 7.96536 13.3225 8.35569C13.3225 8.74601 13.0032 9.06536 12.6129 9.06536Z",
    fill: "#007141"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moto.ba342ac3.svg";
export { ForwardRef as ReactComponent };